import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { Certificate1, Certificate2, Certificate3 } from "src/assets";
import { Box, CardMedia, Divider, Stack } from "@mui/material";

interface CertificateSectionProps {
  showHeadline?: boolean;
}

const CertificateSection = ({
  showHeadline = true,
}: CertificateSectionProps) => {
  const { t } = useTranslation();

  return (
    <>
      {showHeadline && (
        <Stack
          sx={{
            maxWidth: { sm: "300px" },
            textAlign: { xs: "center", sm: "start" },
          }}
        >
          <Text
            text={t("common.CertificateSection.title")}
            sx={{
              fontWeight: 700,
              lineHeight: "21px",
            }}
          />
        </Stack>
      )}

      <Stack
        gap={{ sm: 15, lg: 25 }}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            flexDirection: "column",
            gap: "20px",
            mt: 5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box sx={{ height: "153px" }}>
              <CardMedia
                alt="Zertifikat1"
                component="img"
                image={Certificate1}
                sx={{ height: "100%", width: "auto", objectFit: "contain" }}
              />
            </Box>
            <Box sx={{ height: "153px" }}>
              <CardMedia
                alt="Zertifikat2"
                component="img"
                image={Certificate2}
                sx={{ height: "100%", width: "auto", objectFit: "contain" }}
              />
            </Box>
          </Box>
          <Box
            sx={{ height: "190px", display: "flex", justifyContent: "center" }}
          >
            <CardMedia
              alt="Zertifikat3"
              component="img"
              image={Certificate3}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            gap: "40px",
            alignItems: "center",
            mt: 5,
          }}
        >
          <Box sx={{ height: "153px" }}>
            <CardMedia
              alt="Zertifikat1"
              component="img"
              image={Certificate1}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box sx={{ height: "153px" }}>
            <CardMedia
              alt="Zertifikat2"
              component="img"
              image={Certificate2}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box sx={{ height: "190px", marginLeft: "-52.5px" }}>
            <CardMedia
              alt="Zertifikat3"
              component="img"
              image={Certificate3}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
        </Box>
      </Stack>

      <Divider sx={{ display: { sm: "none" } }} />
    </>
  );
};

export default CertificateSection;
